import * as React from "react";
import { forwardRef } from "react";
const InfoTooltipIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  viewBox: "0 0 16 16",
  fill: "currentColor",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#info-tooltip-icon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M8 1.5C4.41015 1.5 1.5 4.41015 1.5 8c0 3.5899 2.91015 6.5 6.5 6.5 3.5899 0 6.5-2.9101 6.5-6.5 0-3.58985-2.9101-6.5-6.5-6.5M.5 8C.5 3.85786 3.85786.5 8 .5c4.1421 0 7.5 3.35786 7.5 7.5 0 4.1421-3.3579 7.5-7.5 7.5C3.85786 15.5.5 12.1421.5 8",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9 7H7v5h2zm0-3H7v2h2z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "info-tooltip-icon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h16v16H0z"
}))));
const ForwardRef = forwardRef(InfoTooltipIcon);
export { ForwardRef as InfoTooltipIcon };